var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "right-body", attrs: { id: "addEmails" } }, [
    _c(
      "div",
      { staticClass: "all-drives" },
      [
        _c("div", { staticClass: "right-cont-middle" }, [
          _c("div", { staticClass: "right-cont-middle-position" }, [
            _c("span", { staticClass: "connect-desc" }, [
              _vm._v(_vm._s(_vm.$t("language.addEmail.connectDesc")))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right-cont-body" }, [
          _c(
            "div",
            { class: [_vm.rightBoShow ? "cont-box" : "cont-box-order"] },
            [
              _vm.rightBoShow
                ? _c(
                    "div",
                    {
                      staticClass: "drive-add-clouds-up",
                      class: {
                        "up-clouds-none":
                          !_vm.addEmailLine || !_vm.addEmailLine.length
                      },
                      staticStyle: { height: "100%" }
                    },
                    [
                      _c("div", { staticClass: "add-txt" }, [
                        _vm._v(_vm._s(_vm.$t("language.addEmail.peEmail")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "drive-add-cloud-top" },
                        [
                          _vm._l(_vm.addEmailLine, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "drive-add-cloud",
                                on: {
                                  click: function($event) {
                                    return _vm.addEmailDialog(item)
                                  }
                                }
                              },
                              [
                                item.appName
                                  ? _c(
                                      "div",
                                      { staticClass: "add-cloud-item" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "add-cloud-center" },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "cloud cloud-size cloudPosition",
                                              class: item.appName
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "add-cloud-item-name"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.addCloud." +
                                                        item.appName
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "add-cloud-item-name add-cloud-item-name-coming",
                                              staticStyle: { padding: "0" }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            _vm._l(_vm.otherEmailLine, function(item, i) {
                              return _c(
                                "div",
                                { key: i, staticClass: "drive-add-cloud" },
                                [
                                  item.appName
                                    ? _c(
                                        "div",
                                        { staticClass: "add-cloud-item" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "add-cloud-center" },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "cloud cloud-size cloudPosition",
                                                class: item.icon
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "add-cloud-item-name"
                                                },
                                                [_vm._v(_vm._s(item.appName))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "add-cloud-item-name add-cloud-item-name-coming"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "language.addCloud.comingSoon"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            }),
                            0
                          )
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "selectInfo-footer" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.snapTaskIconShow,
                    expression: "snapTaskIconShow"
                  }
                ],
                staticClass: "icon scaling-open scaling-open-position",
                on: {
                  click: function($event) {
                    return _vm.snapTasksOpen()
                  }
                }
              },
              [
                _c("snapTaskDialog", {
                  ref: "snapTaskDialog",
                  on: {
                    cancel: function($event) {
                      return _vm.cancelUpload($event)
                    }
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("addCloudDialog", { ref: "addCloudDialog" }),
        _vm._v(" "),
        _c("addFtpDialog", { ref: "addFtpDialog" }),
        _vm._v(" "),
        _c("detailedProgrssDialog", { ref: "detailedProgrss" }),
        _vm._v(" "),
        _c("retryFailedDialog", { ref: "retryFailedDialog" }),
        _vm._v(" "),
        _c("cancelAllDialog", { ref: "cancelAllDialog" }),
        _vm._v(" "),
        _c("addNasDialog", { ref: "addNasDialog" }),
        _vm._v(" "),
        _c("addSpecialDialog", { ref: "addSpecialDialog" })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54c041a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54c041a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/add_email.vue
// module id = null
// module chunks = 